import { Component, ElementRef, Output, ViewChild } from '@angular/core';
import { UieventhubService } from './helpers/uieventhub/uieventhub.service';
import { SessionHelper } from './helpers/sessionHelper';
import { RouteService } from './helpers/route.service';


import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [UieventhubService]
})
export class AppComponent {
  title = 'et-workapp-frontend';
  //mobilefooter:boolean = false;
  showChat:boolean = false;
  sessionTimeout: any;
  @ViewChild("openchat", { static: false }) openchat: ElementRef;
  constructor(private uieventhubService: UieventhubService,private routerService:RouteService) {
    uieventhubService.showchatcollapse$.subscribe(show => {
      if(show==true){
      // this.openchat.nativeElement.click();
      // this.mobilefooter = true;
      this.showChat = true;
      }else{
      // this.openchat.nativeElement.click();
      //   this.mobilefooter = false;
        this.showChat = false;
      }
    });
      this.extendSession();
  }
  ngAfterViewChecked(){
    //this.uieventhubService.setShowLoader(false);
    if(!this.showChat){
      this.showChat = SessionHelper.getChatShow() != null && SessionHelper.getChatShow() != 'false' ? true : false;
    }
  }
  //on any user interaction, reset the session timeout. After 40 minutes of inactivity, the 'You need to refresh your session' message will appear.
  extendSession(){
   //console.log('Session extended');
    clearTimeout(this.sessionTimeout);
    
    this.sessionTimeout = setTimeout(() => {
      //Show the session timeout message
      if(SessionHelper.getUserSub() != null){
     //console.log('Session timeout');
      document.getElementById("openRefreshModalButton").click();
      }
    }, 2400000);
  
  } 


}
